import api from '@/libs/api'
import store from '@/store'

const projectId = () => store.state.app.projectId

export default {
  namespaced: true,
  state: {
    permissions: [],
    fetchingPermissions: false,
  },
  getters: {
    getPermissions: state => state.permissions.map(x => ({
      subject: x.type.split('.')[1],
      action: x.type.split('.')[2],
      fields: x.type.split('.')[0],
    })),
  },
  mutations: {
    SET_PERMISSIONS(state, permissions) {
      state.permissions = permissions
    },
    FETCHING_PERMISSIONS(state, value) {
      state.fetchingPermissions = value
    },
  },
  actions: {
    fetchPermissions({ commit }) {
      commit('FETCHING_PERMISSIONS', true)
      return new Promise((resolve, reject) => {
        api('captain')
          .get(`/projects/${projectId()}/permissions`, { noSignalNeeded: true })
          .then(response => {
            commit('SET_PERMISSIONS', response.data.result)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => {
            commit('FETCHING_PERMISSIONS', false)
          })
      })
    },
  },
}
